import { SystemWarningsModel } from "models/systemWarnings/systemWarningsModel";
import { SystemWarningsTableModel } from "models/systemWarnings/systemWarningsTableModel";

export enum WarningType {
  AllMessages = "All messages",
  ElectricityMarginNotice = "Electricity Margin Notice",
  DemandControlImminent = "Demand Control Imminent",
  HighRiskOfDemandControl = "High Risk of Demand Control",
  DemandFlexibilityService = "Demand Flexibility Service",
  CapacityMarketNotice = "Capacity Market Notice",
  SpaceWeatherEvent = "Space Weather Event",
  ItSystemsOutage = "IT Systems Outage",
  NegativeReserveActivePowerMargin = "Negative Reserve Active Power Margin",
  SOSOTrades = "SO-SO Trades",
  Other = "Other",
}

const mapWarningTypeToCase = (warningType: string): string => {
  for (const type of Object.values(WarningType)) {
    if (type.toUpperCase() === warningType) {
      return type;
    }
  }
  return WarningType.Other;
};

export const mapToSystemWarningsRow = (
  systemWarningsData: SystemWarningsModel[]
): SystemWarningsTableModel[] =>
  systemWarningsData.map((row) => ({
    id: row.publishTime,
    publishTime: new Date(row.publishTime),
    warningType: mapWarningTypeToCase(row.warningType),
    warningText: row.warningText,
  }));

export const setWarningTypeNullIfAllMessagesSelected = (
  warningType: string
): string | null =>
  warningType === WarningType.AllMessages ? null : warningType;
